import {useState } from "react";
import LocationUpload from "./LocationUpload";

export default function Index() {
    return (
      <>
      <LocationUpload/>
      </>
    );
  
}
